import { render, staticRenderFns } from "./upFileDialog.vue?vue&type=template&id=6a80c7fb"
import script from "./upFileDialog.vue?vue&type=script&lang=js"
export * from "./upFileDialog.vue?vue&type=script&lang=js"
import style0 from "./upFileDialog.vue?vue&type=style&index=0&id=6a80c7fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports